<div class="container">
    @if (data$ | async; as data) {
        @if (data.title) {
            <div class="bulletin-title row align-items-center">
                <div class="col-8 col-sm-6">
                    @if (data.title) {
                        <h3>{{ data.title }}</h3>
                    }
                </div>
                <div class="col-4 col-sm-6 text-right">
                    <a class="show-all d-none d-sm-inline-block" [routerLink]="'/announcements'">{{
                            'aimo.bulletin.showAll' | cxTranslate
                        }}</a>
                    <a class="show-all d-inline-block d-sm-none" [routerLink]="'/announcements'">{{
                            'aimo.product.carousel.showAll' | cxTranslate
                        }}</a>
                </div>
            </div>
        }
    } @else {
        <aimo-spinner></aimo-spinner>
    }
    @if (bulletins$ | async; as bulletins) {
        <div #bulletinList class="bulletin-list row">
            @for (bulletin of bulletins.bulletins; track bulletin.id) {
                <div class="col-12 col-md-6 col-xl-4">
                    <div class="bulletin">
                        <div class="bulletin-image">
                            <cx-media [loading]="'lazy'" [container]="bulletin.picture"></cx-media>
                        </div>
                        <div class="bulletin-description">
                            <div class="bulletin-tag-date">
                <span class="bulletin-tag bulletin-tag-{{ bulletin.category.code }}">{{
                        bulletin.category.name
                    }}</span>
                                <span class="bulletin-date">{{
                                        bulletin.publishingDate | cxDate: ('aimo.dateFormat' | cxTranslate)
                                    }}</span>
                            </div>
                            <div class="d-flex flex-column h-100">
                                <div class="bulletin-description-wrapper flex-xl-grow-1">
                                    <h5 class="bulletin-header">{{ bulletin.title }}</h5>
                                    <div class="bulletin-short-description"
                                         [innerHTML]="bulletin.shortDescription|safeHtml"></div>
                                </div>
                                @if (bulletin.url && !isExternal(bulletin)) {
                                    <a
                                        class="stretched-link mb-2"
                                        [routerLink]="bulletin.url"
                                    >{{ 'aimo.bulletin.openBulletin' | cxTranslate }}</a
                                    >
                                }
                                @if (!bulletin.url && !isExternal(bulletin)) {
                                    <a
                                        class="stretched-link mb-2"
                                        [routerLink]="'/announcement/' + bulletin.id"
                                    >{{ 'aimo.bulletin.openBulletin' | cxTranslate }}</a
                                    >
                                }
                                @if (bulletin.url && isExternal(bulletin)) {
                                    <a
                                        class="stretched-link mb-2"
                                        [href]="bulletin.url"
                                        [target]="getTarget(bulletin)"
                                    >{{ 'aimo.bulletin.openBulletin' | cxTranslate }}</a
                                    >
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    } @else {
        <aimo-spinner></aimo-spinner>
    }
</div>

